import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// @ts-check
import { Block } from '../../abstract/Block.js';
export class Modal extends Block {
  constructor() {
    super();
    _defineProperty(this, "_handleBackdropClick", () => {
      this._closeDialog();
    });
    _defineProperty(this, "_closeDialog", () => {
      this.setOrAddState('*modalActive', false);
    });
    _defineProperty(this, "_handleDialogClose", () => {
      this._closeDialog();
    });
    /** @param {Event} e */
    _defineProperty(this, "_handleDialogMouseDown", e => {
      /** @private */
      this._mouseDownTarget = e.target;
    });
    /** @param {Event} e */
    _defineProperty(this, "_handleDialogMouseUp", e => {
      if (e.target === this.ref.dialog && e.target === this._mouseDownTarget) {
        this._closeDialog();
      }
    });
    this.init$ = _objectSpread(_objectSpread({}, this.init$), {}, {
      '*modalActive': false,
      isOpen: false,
      closeClicked: this._handleDialogClose
    });
  }
  show() {
    if (this.ref.dialog.showModal) {
      this.ref.dialog.showModal();
    } else {
      this.ref.dialog.setAttribute('open', '');
    }
  }
  hide() {
    if (this.ref.dialog.close) {
      this.ref.dialog.close();
    } else {
      this.ref.dialog.removeAttribute('open');
    }
  }
  initCallback() {
    super.initCallback();
    if (typeof HTMLDialogElement === 'function') {
      this.ref.dialog.addEventListener('close', this._handleDialogClose);
      this.ref.dialog.addEventListener('mousedown', this._handleDialogMouseDown);
      this.ref.dialog.addEventListener('mouseup', this._handleDialogMouseUp);
    } else {
      this.setAttribute('dialog-fallback', '');
      let backdrop = document.createElement('div');
      backdrop.className = 'backdrop';
      this.appendChild(backdrop);
      backdrop.addEventListener('click', this._handleBackdropClick);
    }
    this.sub('*modalActive', modalActive => {
      if (this.$.isOpen !== modalActive) {
        this.$.isOpen = modalActive;
      }
      if (modalActive && this.cfg.modalScrollLock) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });
    this.subConfigValue('modalBackdropStrokes', val => {
      if (val) {
        this.setAttribute('strokes', '');
      } else {
        this.removeAttribute('strokes');
      }
    });
    this.sub('isOpen', isOpen => {
      if (isOpen) {
        this.show();
      } else {
        this.hide();
      }
    });
  }
  destroyCallback() {
    super.destroyCallback();
    document.body.style.overflow = '';
    this._mouseDownTarget = undefined;
    this.ref.dialog.removeEventListener('close', this._handleDialogClose);
    this.ref.dialog.removeEventListener('mousedown', this._handleDialogMouseDown);
    this.ref.dialog.removeEventListener('mouseup', this._handleDialogMouseUp);
  }
}
_defineProperty(Modal, "StateConsumerScope", 'modal');
Modal.template = /* HTML */"\n  <dialog ref=\"dialog\">\n    <slot></slot>\n  </dialog>\n";